/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, createRef } from 'react';
import { createPortal } from 'react-dom';
import { Calendar, } from '@fullcalendar/core';
import { CustomRenderingStore, } from '@fullcalendar/core/internal';
export default class FullCalendar extends Component {
    constructor() {
        super(...arguments);
        this.elRef = createRef();
        this.needCustomRenderingResize = false;
        this.state = {
            customRenderingMap: new Map()
        };
    }
    render() {
        const portalNodes = [];
        for (const customRendering of this.state.customRenderingMap.values()) {
            const { generatorMeta } = customRendering;
            const vnode = typeof generatorMeta === 'function' ?
                generatorMeta(customRendering.renderProps) :
                generatorMeta;
            portalNodes.push(createPortal(vnode, customRendering.containerEl, customRendering.id));
        }
        return (React.createElement("div", { ref: this.elRef }, portalNodes));
    }
    componentDidMount() {
        const customRenderingStore = new CustomRenderingStore();
        this.calendar = new Calendar(this.elRef.current, Object.assign(Object.assign({}, this.props), { handleCustomRendering: customRenderingStore.handle.bind(customRenderingStore), customRenderingMetaMap: this.props }));
        this.calendar.render();
        customRenderingStore.subscribe((customRenderingMap) => {
            this.needCustomRenderingResize = true;
            this.setState({ customRenderingMap });
        });
    }
    componentDidUpdate(prevProps) {
        const updates = computeUpdates(prevProps, this.props);
        if (Object.keys(updates).length) {
            this.calendar.resetOptions(updates, true);
        }
        if (this.needCustomRenderingResize) {
            this.needCustomRenderingResize = false;
            this.calendar.updateSize();
        }
    }
    componentWillUnmount() {
        this.calendar.destroy();
    }
    getApi() {
        return this.calendar;
    }
}
// Utils
function computeUpdates(origObj, newObj) {
    const updates = {};
    if (newObj !== origObj) {
        for (const key in newObj) {
            if (newObj[key] !== origObj[key]) {
                updates[key] = newObj[key];
            }
        }
    }
    return updates;
}
//# sourceMappingURL=index.js.map